export function schema_prediction(prevColumnNames) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			action: {
				title: "Action",
				type: "string",
				enum: ["predict", "train"]
			},
			model_id: {
				title: "Nom du modèle",
				type: "string"
			},
			columns: {
				title: "Colonnes",
				type: "array",
				format: "table",
				items: {
					title: "colonne",
					type: "string"
				}
			},
			prediction_column: {
				title: "Colonne de résultats",
				type: "string"
			},
			result_column: {
				title: "Colonne de résultats attendus (mode entraînement)",
				type: "string"
			},
			test_size: {
				title: "Taille des données de tests, entre 0 et 1 (mode entraînement)"
			}
		},
	};
}
